export default __webpack_public_path__ + "static/media/windows-notificacion.cbd5c4be.mp3";